import React, { useState, useCallback } from "react";
import "../../assets/css/form.css";
import TextInput from "../UIkit/TextInput";
import Button from "@material-ui/core/Button";
import { db, FirebaseTimestamp } from "../../firebase";

const contactsRef = db.collection("contacts");

const ContactForm = (props) => {
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const inputDescription = useCallback(
    (event) => {
      setDescription(event.target.value);
    },
    [setDescription]
  );

  const inputEmail = useCallback(
    (event) => {
      setEmail(event.target.value);
    },
    [setEmail]
  );

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );
  const validateEmailFormat = (email) => {
    // const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(email);
  };
  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  const formClear = () => {
    setName("");
    setEmail("");
    setDescription("");
  };

  const saveContact = async (name, email, description) => {
    // console.log("saveContact発火");

    const timestamp = FirebaseTimestamp.now();

    const data = {
      name: name,
      email: email,
      description: description,
      created_at: timestamp,
    };
    await contactsRef
      .doc()
      .set(data)
      .then(() => {
        // console.log("保存成功");
        return;
      })
      .catch((error) => {
        // console.log("保存失敗");
        throw new Error(error);
      });
  };

  const submitForm = () => {
    const isBlank = validateRequiredInput(name, email, description);
    const isValidEmail = validateEmailFormat(email);

    if (isBlank) {
      alert("必須入力欄が空白です。");
      return false;
    } else if (!isValidEmail) {
      alert("メールアドレスの書式が異なります。");
      return false;
    } else {
      saveContact(name, email, description);
      const payload = {
        text:
          "お問い合わせがありました\n" +
          "お名前：" +
          name +
          "\n" +
          "Email:" +
          email +
          "\n" +
          "問い合わせ内容\n" +
          description,
      };
      const url =
        "https://hooks.slack.com/services/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";

      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
      }).then(() => {
        alert("送信が完了しました。追ってご連絡いたします！");
        setDescription("");
        setEmail("");
        setName("");
      });
    }
  };

  return (
    <section className="form-container" id={props.id}>
      <div className="spacer-box--l" />

      <div className="form-container__box center-box">
        <div className="form-container__box--inner yu-gothic center-box">
          <div className="merit-headline center">- お問い合わせ -</div>
          <div className="spacer-box--s" />
          <div className="spacer-box--ss" />
          <div className="center">
            <div className="left inline-block size-10">
              ご入力いただきました個人情報は、当社プライバシーポリシーに従って適正に取り扱われます。このサイト下部のプライバシーポリシーをご覧いただき、ご同意の上で「送信」ボタンを押してください。
            </div>
          </div>
          <div className="spacer-box--m" />
          <div>
            <TextInput
              label={"お名前(必須)"}
              fullWidth
              multiline={false}
              required={true}
              rows={1}
              value={name}
              type={"text"}
              onChange={inputName}
            />
          </div>
          <div>
            <TextInput
              label={"メールアドレス(必須)"}
              fullWidth
              multiline={false}
              required={true}
              rows={1}
              value={email}
              type={"email"}
              onChange={inputEmail}
            />
          </div>
          <div>
            <TextInput
              label={"お問い合わせ内容(必須)"}
              fullWidth
              multiline={true}
              required={true}
              rows={5}
              value={description}
              type={"text"}
              onChange={inputDescription}
            />
          </div>
          <div className="spacer-box--l" />
          <div className="center size-10 text-red">
            内容を確認して「送信する」ボタンを押してください
          </div>
          <div className="spacer-box--s" />
          <div className="center">
            <div className="form-btn hover1" onClick={submitForm}>
              送信
            </div>
            <div className="spacer-box--s" />
            <div>
              <Button onClick={formClear} color="primary">
                クリア
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="spacer-box--l" />
    </section>
  );
};

export default ContactForm;
